import { PortalCheckboxField } from 'components/FormControls';
import * as React from 'react';

interface IProps {
	items: any;
	selectedProducts: string[];
	columnNames: IColumnTitle;
	selectAllProducts: any;
}

interface IColumnTitle {
	number: string;
	category: string;
	salePrice: string;
	sold: string;
	revenue: string;
	sku: string;
	title: string;
	price: string;
	quantity: string;
	status: string;
}

/**
 *
 * @param props
 */
export const ProductsTableHeader = (props: IProps) => {
	const isChecked = props.items.length > 0 && props.items.length === props.selectedProducts.length;
	return (
		<div className={`productsTableHeader ${isChecked ? 'isChecked' : ''}`}>
			<div className="checkboxPosition">
				<PortalCheckboxField
					input={{
						checked: props.items.length > 0 && props.items.length === props.selectedProducts.length,
						onChange: (e: any) => {
							props.selectAllProducts(e.target.checked);
						},
					}}
					type="checkbox"
				/>
				<span className="checkmark" />
				<div className="checkboxArrow" />
			</div>
			<div className="headerTitle">{props.columnNames.number}</div>
			<div className="headerTitle">{props.columnNames.category}</div>
			<div className="headerTitle">{props.columnNames.title}</div>
			<div className="headerTitle">{props.columnNames.price}</div>
			<div className="headerTitle">{props.columnNames.quantity}</div>
			<div className="headerTitle">{props.columnNames.sold}</div>
			<div className="headerTitle">{props.columnNames.sku}</div>
			<div className="headerTitle">{props.columnNames.status}</div>
			<div className="headerTitle"></div>
		</div>
	);
};
